import { formConstants } from '../../../../utils/constants/form-constants';

const TicketsResaleFormData = ({
    ssoAccountResaleTicketsFields
}) => {
    function buildTicketsResaleFormData() {
        const formData = {};
        const {
            resaleTicketsTitle, displayResaleCriteria, resaleTicketsInformation, buyLink, sellLink,
            sellButtonCriteria, buyButtonCriteria, secutixResaleUrl, secutixPointOfSaleId, secutixVirtualOperator,
            resaleTicketsImageSource, resaleTicketsImageText, resaleTicketsFAQTitle, resaleTicketsFAQs, resaleTicketsIntro
        } = ssoAccountResaleTicketsFields;
        formData[formConstants.resaleTicketsTitle] = resaleTicketsTitle;
        formData[formConstants.displayResaleCriteria] = displayResaleCriteria;
        formData[formConstants.resaleTicketsInformation] = resaleTicketsInformation;
        formData[formConstants.buyLink] = buyLink;
        formData[formConstants.sellLink] = sellLink;
        formData[formConstants.sellButtonCriteria] = sellButtonCriteria;
        formData[formConstants.buyButtonCriteria] = buyButtonCriteria;
        formData[formConstants.secutixResaleUrl] = secutixResaleUrl;
        formData[formConstants.secutixPointOfSaleId] = secutixPointOfSaleId;
        formData[formConstants.secutixVirtualOperator] = secutixVirtualOperator;
        formData[formConstants.resaleTicketsImageSource] = resaleTicketsImageSource;
        formData[formConstants.resaleTicketsImageText] = resaleTicketsImageText;
        formData[formConstants.resaleTicketsFAQTitle] = resaleTicketsFAQTitle;
        formData[formConstants.resaleTicketsFAQs] = resaleTicketsFAQs;
        formData[formConstants.resaleTicketsIntro] = resaleTicketsIntro;

        return formData;
    }


    return buildTicketsResaleFormData();
};

export default TicketsResaleFormData;
